import { render, staticRenderFns } from "./Recipe_form.vue?vue&type=template&id=57241650&scoped=true&"
import script from "./Recipe_form.vue?vue&type=script&lang=js&"
export * from "./Recipe_form.vue?vue&type=script&lang=js&"
import style0 from "./Recipe_form.vue?vue&type=style&index=0&id=57241650&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57241650",
  null
  
)

export default component.exports